import { HUB_PATH, PROFILE_PATH } from '../config';

const EXIT_KEY = 'profileExitTo';
const LAST_GAME_KEY = 'profileLastGame';

const isProfilePath = (path) => String(path || '').startsWith(PROFILE_PATH);

function readStorage(storage, key) {
  try {
    return window[storage].getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(storage, key, value) {
  try {
    window[storage].setItem(key, value);
  } catch {
    // Private mode: navigation still works, just without memory.
  }
}

export function rememberProfileExit(path) {
  if (!isProfilePath(path)) writeStorage('sessionStorage', EXIT_KEY, path);
}

export function profileExitPath() {
  const saved = readStorage('sessionStorage', EXIT_KEY);
  return saved && !isProfilePath(saved) ? saved : HUB_PATH;
}

export function rememberProfileGame(key) {
  writeStorage('localStorage', LAST_GAME_KEY, key);
}

export function profileGameKey(appKey) {
  if (appKey === 'dozen' || appKey === 'word') return appKey;
  const saved = readStorage('localStorage', LAST_GAME_KEY);
  return saved === 'dozen' ? 'dozen' : 'word';
}

export function profilePath(username, gameKey) {
  const game = profileGameKey(gameKey);
  return `${PROFILE_PATH}/${encodeURIComponent(username)}/${game}`;
}

export function profileSections(username) {
  return [
    { key: 'word', to: profilePath(username, 'word'), label: 'Слово Дня' },
    { key: 'dozen', to: profilePath(username, 'dozen'), label: 'Дюжина' }
  ];
}
